import React, {useState, useEffect } from 'react'
import { useParams,useNavigate } from 'react-router-dom';
import { MainData } from '../ui/MainData';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../actions/auth';
import  { GetCourseFather }  from '../../controllers/GetCourseFather';
import  { GetCourseInfo }  from '../../controllers/GetCourseInfo';
import { Navbar } from '../../components/ui/NavBar';
import {encode as base64_encode} from 'base-64';
import  { PositionUpdate }  from '../../controllers/PositionUpdate';
import  { positionByCourse }  from '../../controllers/positionByCourse';
import transEs from '../../translate/es.json';
import transCat from '../../translate/cat.json';
import transDe from '../../translate/de.json';
import transEn from '../../translate/en.json';
import transFr from '../../translate/fr.json';
import transOt from '../../translate/ot.json';
import transPr from '../../translate/pr.json';

// Home to display "Unidades"
export const UnitsScreen = () => {
    const dispatch = useDispatch();
    const history = useNavigate();
    const { cursoId } = useParams();
    const [course, setCourse] = useState([]);
    const [list, setList] = useState([]);
    const [background, setBackground] = useState([]);
    const [backgroundType, setBackgroundType] = useState([]);
    let user = useSelector( state => state.auth );
    const langTxt = localStorage.getItem('userLanguage') || 'es';
    let transTxt = transEs;
    if(langTxt === 'es'){
        transTxt = transEs;
    }
    else if(langTxt === 'cat'){
        transTxt = transCat;
    }
    else if(langTxt === 'de'){
        transTxt = transDe;
    }
    else if(langTxt === 'en'){
        transTxt = transEn;
    }
    else if(langTxt === 'fr'){
        transTxt = transFr;
    }
    else if(langTxt === 'pr'){
        transTxt = transPr;
    }
    else{
        transTxt = transOt;
    }
    const token = useSelector((state) => state.ui.token);
    if(!user?.id){
        if(sessionStorage.getItem('userSelect') && token){
            user = JSON.parse(sessionStorage.getItem('userSelect'));
        }
        else{
            dispatch(logout(token));
            history( '/auth/', {
            replace: true
            });
        }
    }
    const [cursoNombre, setCursoNombre] = useState('');
    
    let ran = false;
    useEffect(() => {
        if (ran) return;

            localStorage.removeItem('lessonFather');
            localStorage.removeItem('childFather');
            localStorage.removeItem('gChildFather');
            
            let posN = 0;
            let posUrl = '';
            positionByCourse( token, user.id, localStorage.getItem('courseId'))
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                const duplicates = e.reduce((acc, current) => {
                    const existingElement = acc.find(item => item.id === current.id);
                    
                    if (!existingElement) {
                      acc.push(current);
                    }
                  
                    return acc;
                  }, []);
                if(duplicates[0]?.id){
                    posN = e[0].id;
                }
                if(duplicates[0]?.url){
                    posUrl = e[0].url;
                }
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });
            GetCourseFather(cursoId, user.languaje, token, user.id)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                const duplicates = e.reduce((acc, current) => {
                    const existingElement = acc.find(item => item.id === current.id);
                    
                    if (!existingElement) {
                      acc.push(current);
                    }
                  
                    return acc;
                  }, []);
                  
  
                setList(duplicates);
                let found = [];
                if(duplicates !== undefined || duplicates !== null){
                    found = duplicates.find(element => element?.ending_id === null);
                }
                
                // console.log({found})
                if(found){
                    if(posN !== 0){
                        PositionUpdate( token, user.id, cursoId, `/units/${ localStorage.getItem('courseId') }`, posN)
                        .catch((e)=>{
                            console.error(e);
                            // dispatch(logout(token));
                        });
                    }
                }
                else{
                    if(posUrl === `/units/${ localStorage.getItem('courseId') }`){
                        PositionUpdate( token, user.id, cursoId,`/course/${ cursoId }`, posN)
                        .catch((e)=>{
                            console.error(e);
                            // dispatch(logout(token));
                        });
                    }
                }
                setBackground(duplicates[0].background)
                setBackgroundType(duplicates[0].background_type)
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });

            GetCourseInfo(cursoId, user.languaje, token, user.id)
            .then((e)=>{
                if(e.status === "Token is Expired"){
                    dispatch(logout(token));
                }
                setCourse(e[0]);
                if(e[0]?.name){
                    setCursoNombre(e[0].name)
                }
               
            })
            .catch((e)=>{
                console.error(e);
                // dispatch(logout(token));
            });

            
            return () => (ran = true);
        
        
    }, [cursoId])

    if(cursoId===''){
        history.replace('/home');
    }

    const disCourse = ()=>{
        if(list.status === "Token is Expired" ){
            dispatch(logout(token));
            history( '/auth/login', {
                replace: true
                });  
        }
        let lists = list;
        lists.sort((a, b) => a.id - b.id);

        var count = [];
        for (let i = 0; i < lists.length; i++) {
            if (lists[i].ending_id!==null) {
                count = list[i]
            }
          }
        var countp = []
        if(count?.id){
            countp = lists.find((course) => {
                if(course.id>count.id){
                    return course;
                }       
            });
        }
        else{
            countp = lists[0];
        }
        if(!countp){
            for (let i = 0; i < lists.length; i++) {
                if (lists[i].ending_id === null) {
                    count = list[i]
                    break;
                }
              }
            if(count?.id){
                countp = lists.find((course) => {
                    if(course.id===count.id){
                        return course;
                    }       
                });
            }
            else{
                countp = lists[0];
            }
        }

        return lists.map((unit) => (
            (unit.ending_id!==null)?
            <MainData
            key={unit.id}
            fatherid={cursoId}
            id={unit.id}
            count_id={0}
            status_approved=""
            name={unit.text_value}
            url="/lessons"
            />:
            <MainData
            key={unit.id}
            fatherid={cursoId}
            id={unit.id}
            count_id={(countp.id===unit.id)?0:unit.id}
            status_approved={(countp.id===unit.id)?'pendiente':''}
            name={unit.text_value}
            url={(countp.id===unit.id)?"/lessons":"#"}
            />
   
            ));
        
    }
    
    return (

            <div className="fund-main-unit">
            <Navbar title={cursoNombre}/>
                {
                    (background) && backgroundType==="svg"? <img className="fund-start-b-imgu" src = {`data:image/svg+xml;base64,${base64_encode(background)}`} alt="Back Ground"/>
                    :
                    course && (course.background_home_type==="svg")
                    ?
                    <img className="fund-start-b-imgu" src = {`data:image/svg+xml;base64,${base64_encode(course.background_home)}`} alt="Back Ground"/>
                    :
                    (course.background_home_type!==null)?
                    <img className="fund-start-b-imgu" src = {`data:image/${course.background_home_type}+xml;base64,${btoa(course.background_home)}`} alt="Back Ground"/>
                    :null
                }
                <div className="img-course-back">
                {
                    (course.icon_text_type==="svg")
                    ?
                    <img className="img-course-m" src = {`data:image/svg+xml;base64,${base64_encode(course.icon_text)}`} alt={course.name}/>
                    :
                    (course.icon_text_type!==null)?
                    <img className="img-course-m" src = {`data:image/${course.icon_text_type}+xml;base64,${btoa(course.icon_text)}`} alt={course.name}/>
                    :null
                }
                </div>
                <div className='content-units'>
                    
                {list && disCourse() }
                </div>
            </div>
    )
}

